var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gamePageFrame"}},[_c('iframe',{style:({ width: _vm.gameWidth + 'px', height: _vm.gameHeight + 'px', transform: 'scale(' + _vm.scaleValue + ')' }),attrs:{"allowfullscreen":"true","allow":"autoplay","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }